module.exports = __webpack_public_path__ + "img/FOOTER_LOGO_COLUNAS_LINKS.7d7a5609.png";